"use strict";

define('model/board',['underscore', './group', './board.member'], function (_, GroupModel, BoardMember) {
  var BoardModel = GroupModel.extend({
    defaults: {
      tag: GroupModel.IRB_BOARD
    },
    members: function members(options) {
      return BoardMember.membersCollection(this.id, options);
    },
    membersByDate: function membersByDate(date) {
      return BoardMember.membersByDateCollection(this.id, date);
    },
    createMember: function createMember(person) {
      return new BoardMember({
        group: this.clone(),
        person: person
      });
    }
  }, {
    all: function all(params) {
      var collection = GroupModel.all(_.extend({
        tag: GroupModel.IRB_BOARD
      }, params));
      collection.model = BoardModel;
      return collection;
    }
  });
  return BoardModel;
});

